import React from 'react'
import { Github, Twitter, MessageCircle, Heart } from 'lucide-react'
import { siteConfig } from '@data/site-config'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()
  
  const socialIcons = {
    github: Github,
    twitter: Twitter,
    discord: MessageCircle,
    patreon: Heart,
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-lg overflow-hidden">
                <img 
                  src="/hammer-icon.png" 
                  alt="HammerMUD"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-xl font-bold">
                {siteConfig.title}
              </span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              {siteConfig.description}
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              {Object.entries(siteConfig.social).map(([platform, url]) => {
                if (!url) return null
                const Icon = socialIcons[platform as keyof typeof socialIcons]
                if (!Icon) return null
                
                return (
                  <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                    aria-label={`Follow us on ${platform}`}
                  >
                    <Icon className="w-6 h-6" />
                  </a>
                )
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {siteConfig.navigation.slice(0, 5).map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              {siteConfig.footer.links.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            {siteConfig.footer.copyright}
          </p>
          <div className="mt-4 sm:mt-0">
            <p className="text-gray-400 text-sm">
              Built with ❤️ for the MUD community
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer